<div class="popup-overlay" *ngIf="showPopup" (click)="onOverlayClick($event)">
  <div class="popup-content" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <button class="popup-close-btn" (click)="closePopup()" style="margin: 15px 20px;">✕ 閉じる</button>
    </div>
    <div class="popup-body" *ngIf="patientInfo">
      <div class="popup-list-item patient-basic">
        <div class="popup-list-title">
          <span>{{ '患者' | hospLang }}ID</span>
        </div>
        <div class="popup-list-value">{{ patientInfo.patientId }}</div>
      </div>

      <div class="popup-list-item patient-basic">
        <div class="popup-list-title">
          <span>氏名</span>
        </div>
        <div class="popup-list-value">{{ patientInfo.patientName }}</div>
      </div>

      <div class="popup-list-item patient-basic" style="flex-direction: column; align-items: flex-start;">
        <div class="popup-list-title" style="width: 100%; margin-bottom: 0.625rem;">
          <span>移動履歴（24時間以内）</span>
        </div>
        <div class="movement-list" style="width: 100%;">
          <div *ngIf="loadingHistory" class="popup-no-data">読み込み中...</div>
          <div *ngIf="!loadingHistory && movementHistory && movementHistory.length > 0">
            <div class="movement-item" *ngFor="let history of movementHistory" style="padding: 0.5rem 0; font-size: 0.875rem; border-bottom: 1px solid #f0f0f0;">
              <span class="movement-time" style="margin-right: 0.625rem; font-weight: 600;">{{ getTimeText(history) }}</span>
              <span class="movement-location">{{ getLocationText(history) }}</span>
            </div>
          </div>
          <div *ngIf="!loadingHistory && (!movementHistory || movementHistory.length === 0)" class="popup-no-data" style="color: #999; padding: 1.25rem; text-align: center;">
            24時間以内の移動履歴はありません
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

